import React from 'react';
import './StyledTitle.scss';
import  {ReactComponent as Icon} from '../../../Assets/Icons/title.svg';
const StyledTitle=(props)=>{
    return(
        <div className="styled-title">
          
             <h1 data-aos="zoom-in"
              data-aos-delay={100}>{props.title}</h1>
            <p data-aos="zoom-in"
              data-aos-delay={200}>{props.desc}</p>
        </div>
    )
};
export default StyledTitle ;